import { atom } from 'jotai';
import { atomWithStorage } from 'jotai/utils';
import {
  HelpHeadingText,
  HelpSubText
} from 'modules/dashboard/components/organisms/grid-layout/layouts/layoutUtils/helpContent';
import { WidgetType } from 'modules/dashboard/types/widgets/widget.enums';
import {
  NaturalPersonDetails,
  LegalEntityDetails,
  PortfolioSummary
} from 'modules/dashboard/types/widgets/widget.interfaces';

export const doughnutChartColours = [
  ' #124E57',
  ' #F69521',
  ' #F15A22',
  ' #3D7369',
  ' #103240',
  ' #15808D',
  ' #A5242F'
];

export const otherSegmentColour = ' #A3A580';
export const otherInvestmentName = 'Other';

export const isEditingPersonalDetailsAtom = atomWithStorage<boolean>(
  'isEditingPersonalDetails',
  false
);

export const personalDetailsDataAtom = atomWithStorage<{
  type: string;
  naturalPerson: NaturalPersonDetails;
  legalEntity: LegalEntityDetails;
}>('personalDetails', {
  type: 'natural',
  naturalPerson: {
    type: 'natural',
    title: 'Mr',
    name: 'John',
    surname: 'Doe',
    idNumber: '0000000000000',
    email: 'john.doe@example.com',
    mobileNumber: '0718765623',
    taxNumber: '9861582755278',
    ficaStatus: 'Approved',
    physicalAddress: '12 Street Name, City, Province, 1234',
    workTelephone: '0215556789',
    homeTelephone: '0215557890',
    nationalityCountry: 'South Africa',
    dateOfBirth: '1985-01-01',
    residenceCountry: 'South Africa',
    maritalStatus: 'Married',
    postalAddress: 'PO Box 123, City, Province, 1234',
    country: 'South Africa',
    employmentStatus: 'Employed',
    industry: 'Financial Services',
    sourceOfMoney: 'Salary'
  },
  legalEntity: {
    type: 'legal',
    entityName: 'Doe Investments',
    registrationNumber: '2021/123456/07',
    contactName: 'Jane Doe',
    taxNumber: '9123456789001',
    physicalAddress: '45 Corporate Park, Sandton, 2196',
    ficaStatus: 'Pending',
    entityType: '',
    email: '',
    mobileNumber: '',
    country: '',
    contactPerson: {
      title: '',
      name: '',
      surname: ''
    }
  }
});

export const portfolioSummaryDataAtom = atomWithStorage<PortfolioSummary>('portfolioSummary', {
  startingAmount: 0,
  currentAmount: 0,
  investments: []
});

export const listWidgetDataAtom = atomWithStorage<string[]>('listWidgetData', [
  'Item 1',
  'Item 2',
  'Item 3'
]);

export interface Beneficiary {
  firstName: string;
  surname: string;
  investmentBreakdown: InvestmentBreakdown[];
}

export interface InvestmentBreakdown {
  number: string;
  name: string;
  roles: string[];
}

export const hiddenWidgetsAtom = atomWithStorage<WidgetType[]>('hideWidgetContent', []);

export interface Beneficiary {
  firstName: string;
  surname: string;
  investmentBreakdown: InvestmentBreakdown[];
}

export interface InvestmentBreakdown {
  number: string;
  name: string;
  roles: string[];
}

export const dashboardType = atom<string | undefined>('intermediary');
export const selectedClientName = atom<string>('Client');

export const placeHolderClientName = 'Client';
export const clientNavigationPath = '/clients/:clientId';

export const clientTypeAtom = atom<string | undefined>(undefined);

export const helpTextAtom = atom((get) => {
  const clientType = get(clientTypeAtom);
  return {
    heading:
      clientType === 'Natural'
        ? HelpHeadingText.PersonalDetailsNatural
        : HelpHeadingText.PersonalDetailsLegal,
    subText:
      clientType === 'Natural'
        ? HelpSubText.PersonalDetailsNatural
        : HelpSubText.PersonalDetailsLegal
  };
});
